module.exports = __webpack_public_path__ + "img/board.png";